<script>
import ClientesService from '@/services/clientes.service';
import { EstadoContador, ESTADO_CONTADOR, ESTADO_REGISTRO_CONTADOR, PaginacionDefault, RegistroEstadoContador, Rol } from '@/constants/global';
import Utils from '@/functions/utils';
import authService from '@/services/auth.service';
import spinnerService from '@/services/spinner.service';


export default {

  data() {
    return {
      loading: false,
      roles: Rol,
      asesores: [],
      estados: ESTADO_CONTADOR,
      registros: ESTADO_REGISTRO_CONTADOR,
      errores: {},
      asesorCurrent: {},
      usuario: authService.getUser(),
      revendedor: {
        asesor: -1,
        documento: null,
        nombre: null,
        estado: EstadoContador.PENDIENTE,
        confirmacion: RegistroEstadoContador.PENDIENTE
      }
    }
  },
  mounted() {
    this.getUsuarios();

  },
  methods: {
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
      this.asesorCurrent = this.asesores.find(fnd => fnd.value == this.usuario.idUsuario);
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.idasesor = Rol.ADMINISTRADOR == this.usuario.rol
        && (this.revendedor.asesor == null || this.revendedor.asesor == -1);
      this.errores.documento = this.revendedor.documento == null || this.revendedor.documento.trim() == '';
      this.errores.nombre = this.revendedor.nombre == null || this.revendedor.nombre.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;
      
      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          IdAsesor: this.revendedor.asesor,
          Documento: this.revendedor.documento,
          RazonSocial: this.revendedor.nombre,
          Estado: this.revendedor.estado,
          Confirmacion: this.revendedor.confirmacion,
          Ocupacion: 'Revendedor',
          FechaCreacion: new Date()
        };

        await ClientesService.createContador(obj);
        Utils.mostrarMensajeExito('El Revendedor se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/info/revendedores`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>NUEVO REVENDEDOR SMART</h1>
            <p>REGISTRE LOS DATOS DEL NUEVO REVENDEDOR</p>
          </div>
          <div class="card-body p-5">
            <form id="regis" action="/guardarRecomendador" method="POST">
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="asesor" class="form-control-lg">Asesor de Ventas</label>
                  </div>
                  <div class="col-sm-7">
                    <select v-if="usuario.rol == roles.ADMINISTRADOR" name="cont_asesor" id="cont_asesor"
                      class="req form-select form-control-lg" v-model="revendedor.asesor"
                      v-bind:class="{ 'invalid': errores.idasesor }">
                      <option value="-1">Seleccione un asesor</option>
                      <option v-for="asesor in asesores" :key="asesor.value" :value="asesor.value">
                        {{ asesor.label }}
                      </option>
                    </select>
                    <template v-else>
                      <input type="text" class="form-control form-control-lg" :value="asesorCurrent.label" disabled
                        v-bind:class="{ 'invalid': errores.idasesor }">
                      <input type="hidden" name="cont_asesor" id="cont_asesor" class="form-control form-control-lg"
                        :value="asesorCurrent.value">
                    </template>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del revendedor SMART</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="cont_dni" class="form-control-lg">DNI</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_dni" id="cont_dni"
                      maxlength="11" v-model="revendedor.documento" v-bind:class="{ 'invalid': errores.documento }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cont_nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_nombre" id="cont_nombre"
                      maxlength="255" v-model="revendedor.nombre" v-bind:class="{ 'invalid': errores.nombre }">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Estado del registro</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="estado" class="form-control-lg">Estado</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_estado" id="cont_estado" class="form-select form-control-lg"
                      v-model="revendedor.estado" disabled>
                      <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="confirmacion" class="form-control-lg">Confirmación de registro</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="cont_registro" id="cont_registro" class="form-select form-control-lg"
                      v-model="revendedor.confirmacion" disabled>
                      <option v-for="registro in registros" :key="registro.id" :value="registro.id">
                        {{ registro.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="cont_fec_creacion" id="cont_fec_creacion">
                  <div class="col"><a @click="btnCancelar_click"
                      class="btn btn-danger form-control btn-lg">Cancelar</a></div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                    @click="btnGuardar_click">Guardar</button></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col"></div>
  </div>
</div></template>